/**
 * Home JS
 */

// Vendors
import $ from 'jquery';
import carousel from './framework/carousel';

const video_frame = $('#video-frame');
video_frame.on('click', event => {
  const elm = video_frame;
  const conts = elm.contents();
  const length = conts.length;
  let iframe = null;

  for (let i = 0; i < length; i++) {
    if (conts[i].nodeType == 8) {
      iframe = conts[i].textContent;
    }
  }

  elm.addClass('player').html(iframe);
  elm.off('click');
});

const video_frame_mobile = $('#video-frame-mobile');
video_frame_mobile.on('click', event => {
  const elm = video_frame_mobile;
  const conts = elm.contents();
  const length = conts.length;
  let iframe = null;

  for (let i = 0; i < length; i++) {
    if (conts[i].nodeType == 8) {
      iframe = conts[i].textContent;
    }
  }

  elm.addClass('player').html(iframe);
  elm.off('click');
});

const homeCarouselSettings = {
  infinite: false, // prevent slides from looping
  autoplay: false, // enable automatic slide progression
  dots: false, // display dot indicators
  speed: 500, // set the slide transition speed to half a second
};
const sampleCarousel = carousel(
  '[data-carousel="home-carousel"]',
  homeCarouselSettings
);
